import React from "react";
import { useSearchParams } from "react-router-dom";
import { TitlePage } from "../../longball/player-report";
import { useMLBPlayerBio } from "../../../hooks/use-mlb-player-bio";
import { usePlayerStats } from "../../../hooks/use-player-stats";

export const LongballPlayerReportRender = () => {
  const [searchParams] = useSearchParams();
  const playerId = searchParams.get("player_id") || "";
  const year = searchParams.get("year") ? parseInt(searchParams.get("year"), 10) : null;

  const injected = (typeof window !== "undefined" && window.__PLAYER_STATS__) || null;
  const { stats } = usePlayerStats(injected ? null : playerId, year);
  const { bio } = useMLBPlayerBio(playerId);

  const data = { ...(injected || stats || {}), ...bio };

  return (
    <>
      <style>{`
        html, body {
          margin: 0 !important;
          padding: 0 !important;
          width: 900px !important;
          height: 900px !important;
          overflow: hidden !important;
          background: #ffffff !important;
        }
      `}</style>
      <div data-export-ready="true" data-chart-container>
          <TitlePage data={data} playerId={playerId} />
      </div>
    </>
  );
};
